<template>
  <span class="c-tag-new">Novo</span>
</template>

<script>
export default {
  name: 'CTagNew'
}
</script>

<style lang="scss">
.c-tag-new {
  display: inline-block;
  content: "Novo";
  background: color-var(negative);
  color: white;
  font-size: 9px;
  font-family: Ubuntu;
  font-weight: 500;
  text-transform: uppercase;
  padding: 3px 5px;
  margin-left: 5px;
  margin-right: -5px;
  border-radius: 20px;
  transform: translateY(-1px);
  box-shadow: 0 1px 4px 1px rgba($negative-color, .3);
  vertical-align: middle;
}
</style>
